<template>
  <Base :base-id="'lb-fa-check'">
    <template #body>
      <p>fa points係由fasney發放，欲查詢點數使用紀錄，請下載fasney App查看。</p>
    </template>
    <template #footer>
      <a v-if="isMobile" :href="faUrl" class="btn btn-primary btn-block">確定</a>
      <a v-else href="#" class="btn btn-primary btn-block" @click.prevent="closeModal()"> 確定 </a>
    </template>
  </Base>
</template>

<script setup>
import useModalStore from '@global/stores/useModalStore';
import Base from '@global/components/common/modal/Base.vue';

import useFaPoint from '@global/composable/member/useFaPoint';
import useSetEnv from '@global/composable/useSetEnv';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { faUrl } = useFaPoint();
const { setEnv } = useSetEnv();
const isMobile = setEnv.myEquipment();
</script>
